import React from 'react';
import { Section } from './ui/Section';
export function ProblemSection() {
  return <Section className="bg-navy-800" dark={true} data-id="element-150">
      <div className="space-y-12 text-center md:text-left" data-id="element-151">
        <div className="max-w-3xl mx-auto text-center space-y-6" data-id="element-152">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif leading-tight" data-id="element-153">
            This is for the woman who can handle anything…{' '}
            <span className="text-gold-400 italic" data-id="element-154">
              except turning her brain off.
            </span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center mt-16" data-id="element-155">
          <div className="space-y-6 text-lg text-cream-100/80 leading-relaxed" data-id="element-156">
            <p data-id="element-157">If you're over 40, you've probably been told the same things:</p>
            <ul className="space-y-3 pl-4 border-l-2 border-gold-500/30" data-id="element-158">
              <li data-id="element-159">"Just meditate."</li>
              <li data-id="element-160">"Try melatonin."</li>
              <li data-id="element-161">"Stop caffeine."</li>
              <li data-id="element-162">"Put your phone away."</li>
            </ul>
            <p data-id="element-163">
              And maybe you've tried some of it. But here's what nobody says out
              loud:
            </p>
            <p className="font-serif text-2xl text-gold-400 italic" data-id="element-164">
              Most sleep advice is built for people who don't live in your
              brain.
            </p>
          </div>

          <div className="bg-navy-900 p-8 md:p-10 rounded-2xl border border-navy-700 shadow-xl" data-id="element-165">
            <h3 className="text-2xl font-serif mb-6 text-cream-50" data-id="element-166">
              The Reality
            </h3>
            <div className="space-y-4 text-cream-100/70" data-id="element-167">
              <p data-id="element-168">You replay conversations.</p>
              <p data-id="element-169">You run tomorrow's to-do list.</p>
              <p data-id="element-170">You solve problems that don't even exist yet.</p>
              <p data-id="element-171">
                And if you do fall asleep, you wake up between 2 and 4am—alert,
                tense, and somehow convinced that thinking harder is the only
                way to protect tomorrow.
              </p>
              <div className="pt-6 border-t border-navy-700 mt-6" data-id="element-172">
                <p className="text-lg font-medium text-gold-400" data-id="element-173">
                  You don't need another tip. You need a repeatable shutdown
                  sequence.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}